import * as React from 'react';
import {ICoursePromoContext} from './types';

const CoursePromoContext
  = React.createContext<ICoursePromoContext | any>(undefined);

const {
  Provider: CoursePromoProvider,
  Consumer: CoursePromoConsumer,
} = CoursePromoContext;

export {CoursePromoContext};
export {CoursePromoProvider};
export {CoursePromoConsumer};
